import { useUser } from "src/utils/auth/useUser"
import useSWR from "swr"
import { useMemo } from "react"
import { fetchChatUnreadCount } from "../../models/chat/fetchChatUnreadCount"

/**
 * チャットの未読件数, 新着などを取得
 */
const useChatData = () => {
  const { apiUser } = useUser()

  const { data: unreadCount } = useSWR(
    apiUser?.display_name ? `/v1/mypage/chat/all/unread` : null,
    fetchChatUnreadCount,

    {
      // ポーリング時間
      refreshInterval: parseInt(
        process.env.NEXT_PUBLIC_POLLING_TIME_MS as string,
        10,
      ),
    },
  )

  const unReadChatCount = useMemo(() => {
    return unreadCount !== undefined ? unreadCount : 0
  }, [unreadCount])

  return { unReadChatCount }
}

export { useChatData }
